import { useState } from 'react';
import { useSelector } from 'react-redux';
import fm from 'format-message';
import PropTypes from 'prop-types';
import { useStyletron } from '@activebrands/core-web/libs/styletron';
import CheckoutHeading from 'templates/CheckoutPage/CheckoutHeading';
import ShippingAddress from 'templates/CheckoutPage/ShippingSection/ShippingAddress';

const ShippingSection = ({
    $style,
    addressNewsletterText,
    addressSeprateShippingText,
    addressTermsText,
    basketType,
    currentCheckoutStep,
    infoBoxes,
    setCurrentCheckoutStep,
    shippingStep,
}) => {
    const { address, shippingAddress } = useSelector(state => state.basket);
    const [css] = useStyletron();

    const checkSeparateShippingAddress = () => {
        let hasDifferences = false;
        if (shippingAddress) {
            Object.keys(address).forEach(property => {
                if (shippingAddress[property] !== address[property]) {
                    hasDifferences = true;
                }
            });
        }
        return hasDifferences;
    };

    const [separateBillingAndShippingAddress, setSeparateBillingAndShippingAddress] = useState(
        checkSeparateShippingAddress()
    );

    return (
        <div className={css($style)}>
            <CheckoutHeading
                $style={{ borderBottom: 'none' }}
                editButtonVisible={currentCheckoutStep > shippingStep}
                label={separateBillingAndShippingAddress ? fm('Billing address') : fm('Shipping address')}
                onClickEdit={() => setCurrentCheckoutStep(shippingStep)}
            />
            <ShippingAddress
                address={address}
                addressNewsletterText={addressNewsletterText}
                addressSeprateShippingText={addressSeprateShippingText}
                addressTermsText={addressTermsText}
                basketType={basketType}
                checkSeparateShippingAddress={checkSeparateShippingAddress}
                currentCheckoutStep={currentCheckoutStep}
                infoBoxes={infoBoxes}
                separateBillingAndShippingAddress={separateBillingAndShippingAddress}
                setCurrentCheckoutStep={setCurrentCheckoutStep}
                setSeparateBillingAndShippingAddress={setSeparateBillingAndShippingAddress}
                shippingAddress={shippingAddress}
                shippingStep={shippingStep}
            />
        </div>
    );
};

ShippingSection.propTypes = {
    $style: PropTypes.object,
    addressNewsletterText: PropTypes.object,
    addressSeprateShippingText: PropTypes.object,
    addressTermsText: PropTypes.object,
    basketType: PropTypes.string,
    currentCheckoutStep: PropTypes.number,
    infoBoxes: PropTypes.array,
    setCurrentCheckoutStep: PropTypes.func,
    shippingStep: PropTypes.number,
};

export default ShippingSection;
